import { BookingStates } from '@/components/Booking/models/BookingStates';

export class BookingState {
    id: number;
    name: string;

    klass: object = BookingState;

    constructor(id: number, name: string) {
      this.id = id;
      this.name = name;
    }

    get nameLowerCase(){
        return this.name.toLowerCase();
    }

    get alertClass(){
        switch (this.name){
            case BookingStates.Undefined.name:
            case BookingStates.Open.name:
                return 'lighten-2 black--text';
                break;
            default:
                return '';
                break;
        }
    }

    get color(){
      switch (this.name){
          case BookingStates.Undefined.name:
              return "grey"
          case BookingStates.Open.name: 
              return "orange"              
          case BookingStates.Ok.name: 
              return "green"
          case BookingStates.Finished.name:
              return "blue";
          case BookingStates.Rejected.name:
              return "red"
          case BookingStates.Cancelled.name:
              return "grey"
          default:
              return "pink";
              break;
      }
  }
}

export default BookingState;
